import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const KeyPairsContext = createContext({});

export function KeyPairsProvider({ children }) {
  const { user } = useAuth();
  const [pairs, setPairs] = useState([]);

  const reload = useCallback(async () => {
    if (!user) { setPairs([]); return; }
    try {
      const { data } = await api.get("/keypairs");
      setPairs(data || []);
    } catch { /* noop */ }
  }, [user]);

  useEffect(() => { reload(); }, [reload]);

  const create = async (key, value, value_type = "string") => {
    const { data } = await api.post("/keypairs", { key, value, value_type });
    setPairs((p) => [...p, data]);
    return data;
  };
  const update = async (kp_id, key, value, value_type) => {
    const { data } = await api.put(`/keypairs/${kp_id}`, { key, value, value_type: value_type || "string" });
    setPairs((p) => p.map((x) => x.kp_id === kp_id ? data : x));
    return data;
  };
  const remove = async (kp_id) => {
    await api.delete(`/keypairs/${kp_id}`);
    setPairs((p) => p.filter((x) => x.kp_id !== kp_id));
  };

  return (
    <KeyPairsContext.Provider value={{ pairs, create, update, remove, reload }}>
      {children}
    </KeyPairsContext.Provider>
  );
}

export const useKeyPairs = () => useContext(KeyPairsContext);
